import { render, staticRenderFns } from "./accountingDetail.vue?vue&type=template&id=63b0a55f&scoped=true"
import script from "./accountingDetail.vue?vue&type=script&lang=js"
export * from "./accountingDetail.vue?vue&type=script&lang=js"
import style0 from "./accountingDetail.vue?vue&type=style&index=0&id=63b0a55f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0a55f",
  null
  
)

export default component.exports